import styled, { css } from 'styled-components'

interface Props {
  focused: boolean
  error: boolean
}

export const DefaultInput = styled.input<Props>`
  ${({ theme: { primaryColor }, focused, error }) => css`
    &&&&& {
      height: 50px;
      width: 50px;
      border: 1px solid
        ${error ? '#FF6F61' : focused ? primaryColor : '#e6e8eb'} !important;
      margin-right: 24px;
      padding: 0;
      text-align: center;
      font-size: 20px;
      caret-color: transparent;
      ${error &&
      css`
        transition: border 200ms ease-in-out 400ms;
      `}
    }
  `}
`

export const InputContainer = styled.div<Props>`
  ${({ theme: { primaryColor }, focused, error }) => css`
    &&&&&& {
      display: inline-block;
      position: relative;
      :before {
        display: ${focused ? 'block' : 'none'};
        position: absolute;
        z-index: 10;
        content: '';
        width: 20px;
        bottom: 10px;
        left: 15px;
        height: 1px;
        background-color: ${error ? '#FF6F61' : primaryColor};
        transition: all 600ms ease-in-out;
      }
      :last-child input {
        margin-right: 0;
      }
    }
  `}
`
